import { DEDICATED, FIXED, FREE, HOURLY, RECURRING, BUCKET } from "icons";

// Job type constants with their descriptions
export const JOB_TYPES = {
  fixed: {
    id: "fixed",
    label: "Fixed",
    title: "Fixed Job",
    icon: FIXED,
    description:
      "The total project cost is fixed and agreed upon upfront. It does not change even if more hours are spent than estimated. Similarly, if the job is completed earlier than expected, there are no refunds or discounts. Payment can be collected in full or in defined billables. This type of job is one-time, with a clearly defined scope and timeline.",
  },
  hourly: {
    id: "hourly",
    label: "Hourly",
    title: "Hourly Job",
    icon: HOURLY,
    description:
      "The client agrees to pay based on actual hours worked. An estimated number of hours may be shared initially, but billing depends on actual time spent. There’s no fixed minimum or maximum cost—billing is flexible. Invoices can be raised weekly, bi-weekly, or monthly, based on mutual agreement. This type of job is ideal for evolving requirements and continuous engagement.",
  },
  dedicated: {
    id: "dedicated",
    label: "Dedicated",
    title: "Dedicated Job",
    icon: DEDICATED,
    description:
      "A resource (employee) is assigned fully or partially, exclusively to the client at a fixed monthly rate. The billing does not depend on hours spent but on monthly engagement. However, if the assigned person takes leaves, adjustments may be made based on a predefined leave policy. Leave deductions (if applicable) are calculated at the end of each billing cycle.",
  },
  recurring: {
    id: "recurring",
    label: "Recurring",
    title: "Recurring Job",
    icon: RECURRING,
    description:
      "A job with a fixed duration and a recurring billing cycle, where the client is billed automatically at a defined frequency (weekly, monthly, or yearly) and custom interval. Billing continues as per the selected schedule throughout the job’s active period and stops immediately once the job is closed. Best suited for Managed services, Domain renewals, and subscriptions.",
  },
  bucket: {
    id: "bucket",
    label: "Bucket",
    title: "Bucket Job",
    icon: BUCKET,
    description:
      "A prepaid engagement where the client purchases a fixed amount and number of hours upfront through one-time billing. These hours can be consumed flexibly until the defined expiry date (end date). If additional work is required, a new bucket job must be created with new hours and billing. Best suited for Support, maintenance, marketing, branding, and other on-demand or ad-hoc work.",
  },
  free: {
    id: "free",
    label: "Free",
    title: "Free Job",
    icon: FREE,
    description:
      "Use this for non-billable work like post-live support, internal projects, or pre-sales to accurately track team effort and capacity without impacting revenue, margins, or billability metrics",
  },
};
